import styles from "./cards.module.scss";
import { Card } from "./cardSlice";
import { dateTimeFormat } from "src/utils/utils";
import { EMPTY_STRING } from "src/components/constant/constant";

const columns = [
  {
    title: "Id",
    dataIndex: "id",
    key: "id"
  },
  {
    title: "Card No.",
    dataIndex: "cardNumber",
    key: "cardNumber",
    render: (text: string, card: Card) => (
      <div>
        {card?.cardHolderName ? card?.cardHolderName + "-" : EMPTY_STRING}
        {card.cardNumber ? "****" + card.cardNumber.slice(-4) : EMPTY_STRING}
      </div>
    )
  },
  {
    title: "Status",
    dataIndex: "cardStatus",
    key: "cardStatus",
    render: (cardStatus: string) => (
      <div className={styles.tableCardStatus}>
        <div className={`${cardStatus === "ACTIVE" ? styles.green : styles.grey}`}>{cardStatus}</div>
      </div>
    )
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    render: (created_at: string) => (
      <>
        <div>{dateTimeFormat(created_at).date}</div>
        <div>{dateTimeFormat(created_at).time}</div>
      </>
    )
  },
  {
    title: "Access Type",
    dataIndex: "accessType",
    key: "accessType"
  }
];

export default columns;
